<template>
  <div class="page-container">
    <div class="header">
        <img src="https://bank.giftoceanmall.com/9140420260423110614260.jpg" alt="" class="header_img">
        <div class="header_click" @click="showPopup = true"></div>
    </div>
    <div class="goodsList" v-for="(item,index) in goodsList"  @click="goDetail(item.id)" style="margin-bottom: 15px;">
      
      <div class="goods_img">
        <div class="goods_xl">
          <!-- <img src="https://bank.giftoceanmall.com/477fc202604231134248630.png" alt=""> -->
           <p>限量</p>
           <p>100</p>
        </div>
        <img :src="item.img" alt="">
      </div>
      <div class="goods_info">
        <div class="info_tit">
          {{ item.tit }}
        </div>
        <div class="info_name">
          {{item.name}}
        </div>
        <div class=""></div>
      </div>
    </div>
    <div class="goods_list">
      <div class="goods_list_tit">
        捡漏专区
      </div>
      <div class="product-list" >
        <div class="product-card" v-for="(item,index) in jlzq">
            <div class="discount-tag">直降{{(item.oldprice-item.price).toFixed(1)}}元</div>
            <img :src="item.img" alt="ELLE时尚箱包" class="product-img">
            <div class="product-name">{{item.name}}</div>
            <div class="installment">分期 ¥{{(item.price/9).toFixed(2)}}*9</div>
            <div class="price-area">
                <span class="price-label">活动价</span>
                <span class="price">{{item.price}}</span>
            </div>
        </div>
      </div>
    </div>
    <div class="goods_list goods_list1">
      <div class="goods_list_tit">
        畅销专区
      </div>
      <div class="product-list" >
        <div class="product-card" v-for="(item,index) in cxzq">
            <div class="discount-tag">直降{{(item.oldprice-item.price).toFixed(1)}}元</div>
            <img :src="item.img" alt="ELLE时尚箱包" class="product-img">
            <div class="product-name">{{item.name}}</div>
            <div class="installment">分期 ¥{{(item.price/9).toFixed(2)}}*9</div>
            <div class="price-area">
                <span class="price-label">活动价</span>
                <span class="price">{{item.price}}</span>
            </div>
        </div>
      </div>
    </div>
    <div class="goods_list">
      <div class="goods_list_tit">
        生活好物
      </div>
      <div class="product-list" >
        <div class="product-card" v-for="(item,index) in shhw">
            <div class="discount-tag">直降{{(item.oldprice-item.price).toFixed(1)}}元</div>
            <img :src="item.img" alt="ELLE时尚箱包" class="product-img">
            <div class="product-name">{{item.name}}</div>
            <div class="installment">分期 ¥{{(item.price/9).toFixed(2)}}*9</div>
            <div class="price-area">
                <span class="price-label">活动价</span>
                <span class="price">{{item.price}}</span>
            </div>
        </div>
      </div>
    </div>
    <div class="goods_btn">
      更多特惠好物 低价抢购
    </div>
    <div class="demo-page">
        <MobilePopup 
        :visible="showPopup"
        @close="showPopup = false"
        content-width="90%"
        :border-radius="16"
        > 
        </MobilePopup>
    </div>
  </div>

   
</template>

<script>
import { goShopDetail } from "@libs/order";
import MobilePopup from './MobilePopup.vue'
export default {
  name: 'Activity1',
  components: {
    MobilePopup
  },
  data() {
    return {
      showPopup:false,
      goodsList:[
        {
          id:53,
          name:'海尔家用手持除螨仪703R',
          tit:'双拍打紫外线热风除湿除螨机 99.9%杀菌',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250613/d047693c23116dfc65e21d10ff5c7669.jpg',
          oldprice:'799',
          price:'179',
          fenqi:'59.67*3期',

        },
        {
          id:117,
          name:'海尔多功能1.2L恒温壶HBM-H118E',
          tit:'恒温随享 不再喝凉水',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/925142614778bfd696d861148edca9a8.jpg',
          oldprice:'199',
          price:'139',
          fenqi:'46.3*3期',
          
        },
        {
          id:49,
          name:'海尔喵星人手持挂烫机HY-MC12H',
          tit:'熨烫机家用小型蒸汽熨斗',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250613/bed850633b56ed4b820dec1af6135108.jpg',
          oldprice:'189',
          price:'129',
          fenqi:'43*3期',
          
        },
        {
          id:119,
          name:'完美日记 倾色慕光唇膏迷你套组 （升级版）',
          tit:'一盒集结六色',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/6f8d9b2a6dbbcd7868af7292d186232a.jpg',
          oldprice:'106',
          price:'74',
          fenqi:'24.67*3期',
          
        }
      ],
      jlzq:[
        
        {
          id:156,
          name:'罗莱腰腹揉腹按摩器LUOLAI-CLD100RF',
          price:'139',
          oldprice:'169',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/4c8dedcdb38c09cb1356d96565aa705b.png',
        },
        {
          id:123,
          name:'海尔兄弟（HAIERBROS） 保温杯HB-BT101A',
          price:'19.9',
          oldprice:'39',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/91611e86ef5a50ebccaac7a270099d58.jpg',
        },
        {
          id:141,
          name:'海尔剃须刀男士新款便携迷你官方正品小钢炮旅行电动刮胡刀 HSQ1-2218升级版',
          price:'59',
          oldprice:'79',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/07693b6f62dc06ae45b69302aa2ca419.jpg',
        },
        {
          id:150,
          name:'完美日记 氨基酸轻柔净澈卸妆水 500ml',
          price:'35',
          oldprice:'60',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/72fe685d2712eaceba73b77f0974e4d1.jpg',
        },
        {
          id:135,
          name:'飞利浦3c认证磁吸magsafe充电宝便携迷你无线快充移动电源DLP9505 骑士灰 5000毫安',
          price:'119',
          oldprice:'139',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/784cab36b375c1ca2cc8dcdf0f75037d.jpg',
        },
         {
          id:144,
          name:'美的（Midea）电饭煲飞快系列家用4L不粘锅快速煮饭柴火饭4升电饭锅 MB-TQ453SZ',
          price:'219',
          oldprice:'474',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/9aaa76b532849a3c47d1290525f34238.jpg',
        },

      ],
      cxzq:[
        {
          id:3,
          name:'海尔（Haier）空气炸锅 JL30D升级 3L',
          price:'189',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/05/20250522/17242ef6bb381daa0964e54053b95036.jpg',
          oldprice:'219'
        },
        {
          id:140,
          name:'海尔（Haier）电动牙刷 HTA2-HYB小摩刷 皓月白',
          price:'59',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/3afb0aef99f24a62475d86ee53d11ce9.jpg',
          oldprice:'499'
        },
        {
          id:53,
          name:'海尔（Haier）手持大吸力大功率轻盈机身高效除尘 真空吸尘器除螨仪HZ-C703R',
          price:'179',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250613/d047693c23116dfc65e21d10ff5c7669.jpg',
          oldprice:'199'
        },
        {
          id:39,
          name:'海尔吸尘器HT-C2160B有线手持吸猫毛小型推杆大吸力可视化尘杯',
          price:'129',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250611/76159d8d0d082b3fba369793c41a3b4c.jpg',
          oldprice:'299',
        },
        {
          id:38,
          name:'海尔(Haier)颈椎按摩器肩颈按摩仪颈部斜方肌腰部背部揉捏热敷礼物 X602Z（米色）',
          price:'169',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/06/20250609/057742fee607415b732524e0069afa47.jpg',
          oldprice:'499'
        },
        {
          id:164,
          name:'海尔吸尘器自集尘基站家用手持无线大吸力集尘管家绿光除螨毛发防缠节日礼物HSC-SA301D',
          price:'999',
          img:'https://bank.giftoceanmall.com/0cf03202603261652114320.jpg',
          oldprice:'1299'
        },
        
      ],
      smth:[
         {
          id:157,
          name:'飞利浦（PHILIPS）骨传导概念耳夹式运动跑步蓝牙耳机长续航高端降噪',
          price:'199',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/7e8d32747a943fd9aee010bb31ffb4e4.jpg',
        },
        {
          id:153,
          name:'飞利浦（PHILIPS）真无线蓝牙耳机手机通话降噪运动跑步重低音音乐TAT1168',
          price:'199',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/f7c2f3d1aea8888ecd5d58120a820cce.jpg',
        },
        {
          id:135,
          name:'飞利浦3c认证磁吸magsafe充电宝便携迷你无线快充移动电源DLP9505 骑士灰 5000毫安',
          price:'119',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/784cab36b375c1ca2cc8dcdf0f75037d.jpg',
        },
        {
          id:155,
          name:'韶音（SHOKZ）OpenFit Air T511开放式耳机挂耳式蓝牙耳机黑/白',
          price:'419',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/c102c909bbdc02def578fb7ed93a55ea.jpg',
        },
        {
          id:154,
          name:'韶音（SHOKZ）OpenRun Air S803骨传导耳机黑/紫',
          price:'489',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/ed152b128939497a6777672e82580985.jpg',
        },
       
      ],
      shhw:[
        {
          id:129,
          name:'蔬果园家居清洁系列礼盒9件套A-22',
          price:'89',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/1a60aaf044ec2208a251e19805e67ac2.jpg',
          oldprice:'129'
        },
        {
          id:130,
          name:'蔬果园香雪苍兰香氛洗衣凝珠-8g*52颗',
          price:'22.9',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/01/20260122/cf62a2e2fc46fd891132615ffe8ee717.png',
          oldprice:'39'
        },
        {
          id:81,
          name:'SukGarden蔬果园橘彩星光果蔬餐具净1+1特惠装（半透瓶）800g*2',
          price:'22.9',
          img:'https://bank.giftoceanmall.com/uploads/attach/2025/09/20250924/d16c03f929a075582a5194f8a01a39b2.png',
          oldprice:'29.9'
        },
        {
          id:139,
          name:'公牛BULL TQU006盒装黑色大魔方插座(8979)3*1.0-1.8m',
          price:'79',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/60886d2fe05d8c62fa86a4f673b5640d.jpg',
          oldprice:'98.5'
        },
        {
          id:137,
          name:'公牛（BULL）S1120新国标插座 3位总控全长1.8米',
          price:'59',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/a5aabc3109c0e85471991228612e5682.jpg',
          oldprice:'99'
        },
        {
          id:138,
          name:'公牛BULL 218(S)吸塑装延长线插座(2459)3*1.0*5m*10H',
          price:'85',
          img:'https://bank.giftoceanmall.com/uploads/attach/2026/02/20260203/0b6d99f259451bd2fb18cc3241f13029.jpg',
          oldprice:'93.6'
        },
        
      ],
      
    }
      
  },
  methods: {
    goDianpu() {
      
     
        this.$router.push({ path: "/"});
    
    },
    goDetail(id) {
      console.log(id);
      goShopDetail(id).then(() => {
        this.$router.push({ path: "/detail/" + id });
      });
    },
  }
}
</script>

<style scoped lang="scss">
.page-container{
  width: 100%;
  height: auto;
  background-color: #d41b2e;
  padding-bottom: 30px;
}
.header{
  width: 100%;
  height: auto;
  position: relative;
  .header_img{
    width: 100%;
  }
  .header_click{
    position: absolute;
    width: 50px;
    height: 80px;
    top: 0px;
    right: 0px;
  }
}
.goodsList{
  width: 90%;
  margin: 0 auto;
  background-color: #fff;
  height: 150px;
  border-radius: 10px;
  display: flex;
  .goods_img{
    width: 150px;
    height: 150px;
    border-radius: 10px 0px 0px 10px;
    position: relative;
    img{
      width: 150px;
      height: 150px;
      border-radius: 10px 0px 0px 10px;
    }
    .goods_xl{
      width: 38px;
      height: 36px;
      position: absolute;
      top:-2px;
      left: 20px;
      background-image: url(https://bank.giftoceanmall.com/477fc202604231134248630.png) ;
      background-size: 100%;
      color: #fff;
      font-size: 10px;
      text-align: center;
      
    }
  }
  .goods_info{
    width: 230px;
    height: 150px;
    background-color: #fcebef;
    border-radius: 0px 10px 10px 0px;
  }
  
}
.goods_list{
    width: 95%;
    // height: 490px;
    margin: 0 auto;
    background-image: url(https://bank.giftoceanmall.com/496e720260423143922258.png);
    background-size: 100%;
    .goods_list_tit{
      width: 150px;
      color: #fcedf1;
      font-size: 24px;
      text-align: center;
      line-height: 60px;
      font-weight: bold;
    }
}
.goods_list1{
  width: 95%;
    // height: 490px;
    margin: 0 auto;
    background-image: url(https://bank.giftoceanmall.com/7a778202604231532404568.png);
    background-size: 100%;
    .goods_list_tit{
      width: 150px;
      color: #fcedf1;
      font-size: 24px;
      text-align: center;
      line-height: 60px;
      font-weight: bold;
    }
}
.product-list {
      display: -webkit-grid;
      display: grid;
      grid-template-columns: repeat(3, minmax(80px, 1fr));
      gap: 4px;
      width: 93%;
      -webkit-grid-template-columns: repeat(3, minmax(80px, 1fr));
      margin: 0 auto;
  }

  .product-card {
      border: 1px solid #ff4400;
      border-radius: 4px; 
      padding: 5px; 
      text-align: center;
      background-color: #fff;
      position: relative;
      overflow: hidden;
  }
  .discount-tag {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #ff4400;
      color: #fff;
      font-size: 10px; 
      padding: 2px 4px;
      border-radius: 0 0 4px 0;
      font-weight: bold;
  }
  .product-img {
      width: 100%;
      height: 110px; 
      object-fit: contain;
      margin: 5px 0;
  }

  .product-name {
      font-size: 11px; 
      color: #333;
      line-height: 1.3;
      margin: 3px 0;
      height: 30px; 
      overflow: hidden;
  }

  .installment {
      font-size: 10px;
      color: #666;
      margin: 2px 0;
  }

  .price-area {
      display: flex;
      align-items: baseline;
      justify-content: center;
      gap: 2px;
      margin: 3px 0;
      width: 100%;
      background: #ff4400;
      
  }

  .price-label {
      font-size: 10px;
      color: #fff;
  }

  .price {
      font-size: 14px; 
      color: #fff;
      font-weight: bold;
  }
  .goods_btn{
    width: 65%;
    height: 46px;
    margin: 30px auto;
    background-image: url(https://bank.giftoceanmall.com/a2dc8202604231550053177.png);
    background-size: 100%;
    text-align: center;
    color: #fff;
    font-size: 20px;
    line-height: 46px;
  }
      
</style>